import API from '../api';

export const uploadFile = (formData, config) => API.post('/api/v1/document', formData, config);

export const documentTypes = () => API.get('/api/v1/document/types');
